/**
 * お客様の声スワイパー機能の初期化
 */
const customerVoiceSwiper = () => {
  if (document.querySelector('.js-swiper-customer-voice')) {
    new Swiper('.js-swiper-customer-voice', {
      slidesPerView: 1,
      spaceBetween: '2%',
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 500,
      navigation: {
        nextEl: '.swiper-button-next.swiper-button-next--customer-voice',
        prevEl: '.swiper-button-prev.swiper-button-prev--customer-voice',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: '3%',
        },
      },
    });
  }
};

export { customerVoiceSwiper };
